<template>
  <v-slide-y-transition mode="out-in">      
    <div>
      <v-tabs      
        dark v-model="active"
        v-bind:color="kompetisi ? kompetisi.color : 'black'"
        show-arrows      
      >    
        <v-tabs-slider color="yellow"></v-tabs-slider>      
        <v-tab v-for="(item, i) in tabs" :key="i">{{item.name}}</v-tab>            
        <v-tabs-items>
          <v-progress-linear color="info" :indeterminate="true" v-if="loading" height="5" class="ma-0"></v-progress-linear>    
          <v-tab-item v-for="(item, i) in tabs" :key="i">
            <v-card flat>            
              <v-card-text>
                <v-card v-if="kompetisi">
                  <v-toolbar>
                    <v-text-field
                      flat
                      solo
                      append-icon="search"
                      placeholder="Type something"
                      v-model="item.areaSearch"
                      hide-details
                    ></v-text-field>
                    <v-tooltip bottom>
                      <v-btn slot="activator" :loading="loading" icon @click="refreshKompetisi(i)">
                        <v-icon>refresh</v-icon>            
                      </v-btn>
                      <span>Refresh</span>
                    </v-tooltip>  
                    <v-spacer></v-spacer>            
                    <v-chip dark v-bind:color="quickcountMode?'warning':'success'">
                      <v-switch v-model="quickcountMode" v-bind:true-value="true" v-bind:false-value="false" class="mb-1" hide-details              
                      ></v-switch> {{quickcountMode ? 'Quickcount':'Realcount'}}
                    </v-chip>    
                  </v-toolbar>
                  <template v-if="!item.areaSearch && i>0 && item.show">
                    <v-card-text class="pa-1">
                      <v-layout row wrap>
                        <v-flex lg6 sm6 xs12 class="pa-2">                                                
                          <template>
                            <template v-if="i===1">                               
                              <e-chart :key="'a'+(item.time+item.id)" v-if="!quickcountMode" v-bind:option="setBar3Option(item)" height="250px" width="100%"/>                  
                              <e-chart :key="'b'+(item.time+item.id)" v-else v-bind:option="setBar3Option(item, true)" height="250px" width="100%"/>                                                         
                            </template>
                            <template v-else>
                              <e-chart :key="'a'+(item.time+item.id)" v-if="!quickcountMode" v-bind:option="setBar1Option(item)" height="250px" width="100%"/>                  
                              <e-chart :key="'b'+(item.time+item.id)" v-else v-bind:option="setBar1Option(item, true)" height="250px" width="100%"/>                                                         
                            </template>
                            <table style="width:100%" v-if="!quickcountMode">
                              <tr>
                                <td class="text-xs-left"><span class="title blue--text"><v-icon color="blue">accessibility</v-icon> {{item.sah.sah?item.sah.sah:0}}</span>/<small>{{item.pt?item.pt:0}} &nbsp; telah memilih</small></td>
                                <td class="text-xs-right"><small>tidak sah </small><span class="title red--text">{{item.sah.tdk_sah?item.sah.tdk_sah:0}}  <v-icon color="red">layers_clear</v-icon></span></td>
                              </tr>                        
                            </table>            
                            <v-divider></v-divider>
                            <table style="width:100%">
                              <tr>
                                <td class="text-xs-left"><span class="subheading" :class="colorPersen(persenContain(item.contain))+'--text'"><v-icon small :color="colorPersen(persenContain(item.contain))">trending_up</v-icon> {{persenContain(item.contain)}}% </span> to complete</td></td>
                                <td class="text-xs-right"><v-chip :color="kompetisi.color" small dark>
                                  <v-avatar><v-icon small>alarm</v-icon></v-avatar>
                                  <small>{{item.sah.updated_at?$moment(item.sah.updated_at*1000).fromNow():null}}</small></v-chip></td></td>
                              </tr>                        
                            </table>     
                          </template>
                        </v-flex>
                        <v-flex lg6 sm6 xs12 class="tabular">                        
                          <v-data-table style="max-height: 330px; overflow-y: auto"
                            :headers="[  
                              {text:'No',value:'index',sortable:false},
                              {text:'Urut',sortable:false,value:'no',align:'center'},
                              {text:'',value:'i',sortable:false},{ text: 'Rank Sementara', value:'value'},
                              {text:'Suara',sortable:false,value:'value'}
                            ]"
                            :items="item.calons"  
                            :pagination.sync="pagination"
                            hide-actions
                            >
                            <template slot="items" slot-scope="props"> 
                              <tr :style="i===1 && (props.index+1)<=item.kuota? 'background:#D4FFD4':''">      
                                <td>{{props.index+1}}</td>
                                <td>
                                  <v-chip :color="props.item.color" dark>{{props.item.no}}</v-chip>                                  
                                </td>
                                <td>
                                  <v-avatar size="35">
                                    <img :src="props.item.thumb ? props.item.thumb :require('@/assets/img/avatar/blank-dpd.jpg')">
                                  </v-avatar>
                                </td>
                                <td>                                
                                    <v-list-tile-title v-html="props.item.name"></v-list-tile-title>                                 
                                </td>     
                                <td>
                                  <span class="subheading" v-if="!quickcountMode">{{props.item.value?props.item.value:0}} %</span>
                                  <span class="subheading" v-else>{{props.item.hitung.quickcount?props.item.hitung.quickcount:0}} %</span>
                                </td>
                              </tr>                            
                            </template>

                          </v-data-table>                                                
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </template>  
                </v-card>  
                <v-container grid-list-lg fluid pa-0 mt-3 pb-3>
                  <v-layout row wrap>
                    <template v-for="(data) in item.area.data">
                      <v-flex lg4 sm6 xs12 v-if="i>0 && data.is_author">                    
                        <v-card class="cursor elevation-4" @click="newTab(data,i+1)" >                        
                          <v-card-text class="pa-0">
                            <div class="layout row ma-0 align-center justify-space-between">
                              <div class="text-box pa-3">
                                <div class="subheading pb-2"><strong>{{data.name}}</strong></div>                             
                              </div>
                              <div class="chart mr-2">
                                <e-chart :key="'c'+item.time" v-if="!quickcountMode" v-bind:option="setBar2Option(data)" height="150px" width="150px"/>                  
                                <e-chart :key="'d'+item.time" v-else v-bind:option="setBar2Option(data, true)" height="150px" width="150px"/>                                                                                   
                              </div>                          
                            </div>
                            <v-flex xs12 pt-0 mt-0 mb-0 pb-2>
                              <table style="width:100%; margin-top: -20px" v-if="!quickcountMode">
                                <tr>
                                  <td class="text-xs-left"><span class="caption indigo--text"><v-icon small color="indigo">accessibility</v-icon> {{data.sah.sah?data.sah.sah:0}}</span>/<small>{{data.pt?data.pt:0}}</small></td>
                                  <td class="text-xs-right"><span class="caption red--text">{{data.sah.tdk_sah?data.sah.tdk_sah:0}}  <v-icon small color="red">layers_clear</v-icon></span></td>
                                </tr>                        
                              </table>            
                              <v-divider></v-divider>
                              <table style="width:100%">
                                <tr>
                                  <td class="text-xs-left">
                                    <span class="caption" :class="colorPersen(persenContain(data.contain))+'--text'"><v-icon small :color="colorPersen(persenContain(data.contain))">trending_up</v-icon> {{persenContain(data.contain)}}% </span>
                                    <span class="caption blue--text"><v-icon small color="blue">store</v-icon> {{data.contain?quickcountMode?data.contain.quick:data.contain.done:0}}</span>/<small>{{data.contain?data.contain.all:0}} tps</small>
                                  </td>
                                  <td class="text-xs-right">                                
                                    <small>{{data.sah.updated_at?$moment(data.sah.updated_at*1000).fromNow():null}}</small>&nbsp;
                                    <v-icon small>alarm</v-icon>
                                  </td>
                                </tr>                        
                              </table>
                            </v-flex>
                          </v-card-text>                        
                        </v-card> 
                      </v-flex>
                      <v-flex lg6 sm6 xs12 v-else-if="i==0">  
                        <v-card >
                          <v-toolbar flat dense cad>
                            <div class="title">{{data.name}}</div>                          
                            <v-chip dark :color="kompetisi.color">{{data.kuota}}<v-icon right>weekend</v-icon></v-chip>
                            <v-spacer></v-spacer>
                            <slot name="widget-header-action">{{data.sah.updated_at?$moment(data.sah.updated_at*1000).fromNow():null}}</slot>
                          </v-toolbar>

                          <v-card-text class="pa-0">
                            <template>                            
                              <e-chart :key="'a'+(data.time+data.id)" v-if="!quickcountMode" v-bind:option="setBar3Option(data)" height="250px" width="100%"/>                  
                              <e-chart :key="'b'+(data.time+data.id)" v-else v-bind:option="setBar3Option(data, true)" height="250px" width="100%"/>                                                         
                              <div class="pa-2">
                              <table style="width:100%" v-if="!quickcountMode">
                                <tr>
                                  <td class="text-xs-left"><span class="title indigo--text"><v-icon color="indigo">accessibility</v-icon> {{data.sah.sah?data.sah.sah:0}}</span>/<small>{{data.pt?data.pt:0}} &nbsp; telah memilih</small></td>
                                  <td class="text-xs-right"><small>tidak sah </small><span class="title red--text">{{data.sah.tdk_sah?data.sah.tdk_sah:0}}  <v-icon color="red">layers_clear</v-icon></span></td>
                                </tr>                        
                              </table>                                           
                              </div>
                            </template>
                          </v-card-text>
                          <v-divider></v-divider>                            
                          <v-card-actions>
                            <router-link :to="liveRoute(data.dapil_id)" class="mr-2"><v-btn dark v-bind:color="kompetisi.color"><span class="red--text">Li</span>ve</v-btn></router-link>                    
                            <v-btn dark  @click="newTab(data,i+1)" :color="kompetisi.color">Explore</v-btn>
                            <v-spacer></v-spacer>
                            <span :class="colorPersen(persenContain(data.contain))+'--text'"><v-icon small :color="colorPersen(persenContain(data.contain))">trending_up</v-icon> {{persenContain(data.contain)}}%</span> &nbsp;                            
                            <span class="caption blue--text"><v-icon small color="blue">store</v-icon> {{data.contain?quickcountMode?data.contain.quick:data.contain.done:0}}</span>/<small>{{data.contain?data.contain.all:0}} tps</small>
                          </v-card-actions>
                        </v-card> 
                      </v-flex>
                    </template>  
                    <v-flex lg4 sm6 xs12 v-if="tabs[i].area.data.length < tabs[i].area.count">
                      <v-btn v-if="i>0"  class="my-0" block color="info" :loading="loading" small dark @click="setAreas(tabs[i])">load more ...</v-btn>
                      <v-btn v-else block  class="my-0" color="info" :loading="loading" small dark @click="setDapils(tabs[i])">load more ...</v-btn>
                    </v-flex>  
                  </v-layout> 
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
      <form-dialog :dialog="dialog" :cekup="cekup" v-on:closeDialog="closeDialog($event)"></form-dialog>
    </div>  
  </v-slide-y-transition>
</template>

<script>  
import EChart from '@/components/chart/echart';    
import DBar1  from '../../components/data-chart/bar-1';
import DBar2  from '../../components/data-chart/bar-2';
import DBar3  from '../../components/data-chart/bar-3';
import Model  from '@/apps/frc/models/Dashboard';   
import FormDialog from './dialog';
const  model = new Model();

export default {    
    components: {
      EChart,
      FormDialog
    },
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
      tabs : [],
      active : 0,
      search : [], 
      kompetisi_id : null,
      kompetisi : null,                      
      formPath : '/kompetisi/form',      
      loading  : true,
      pagination : {'sortBy': 'value', 'descending': true, 'rowsPerPage': -1},      
      quickcountMode : false,      
      maxvalue: 0,
      dialog : false,
      cekup  : {
        kompetisi_id : null,
        tps_id : null,
        mode : null,
      } 
    }),     
    watch:{
    },
    asyncComputed:{
      back(){
        if(this.$route.query.tingkat_ids){
          let a_ids = this.$route.query.area_ids;
          let area_ids    = Array.isArray(a_ids) ? a_ids : [a_ids];
          if((this.tabs.length-1) > area_ids.length){
            this.active = (area_ids.length);          
          }
        } else {
          this.active = 0;
        }
        return true;
      }
    },
    mounted(){ this.init() },        
    created () {},
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},                
        
        closeDialog(e){
          this.dialog = e.dialog;
          this.cekup  = e.cekup;             
        },
        
        init(){                      
          if(this.kompetisi_id !== this.$route.query.kompetisi_id){
            this.loading = true;            
            this.kompetisi_id = this.$route.query.kompetisi_id;
            model.kompetisi({id:this.$route.query.kompetisi_id, noattr:1}).then(res=>{                  
                let index = 0;                 
                this.kompetisi = res.data;                       
                this.newTab(res.data,index);

                if(this.$route.query.tingkat_ids){   
                    this.loading = true;
                    let a_ids = this.$route.query.area_ids;
                    let t_ids = this.$route.query.tingkat_ids;                      
                    let area_ids    = Array.isArray(a_ids) ? a_ids : [a_ids];
                    let tingkat_ids = Array.isArray(t_ids) ? t_ids : [t_ids];
                    
                    let arr = this.urutkan(tingkat_ids, area_ids);                      
                    this.setTabs(arr);                                           
                } 
            });
          }                                        
        },
        
        async setTabs(arr){
            var index = 1;
            for(var i in arr){
                if(arr[i].b && i>0){
                  let res = await model.areas({dapil_id:this.$route.query.dapil_id,tingkat:arr[i].a,'AreaSearch[id]':arr[i].b,kompetisi_id:this.kompetisi_id});
                  this.newTab(res.data.data[0], index++);                
                } else {
                  let res = await model.dapils({'DapilSearch[id]':this.$route.query.dapil_id,kompetisi_id:this.kompetisi_id});
                  this.newTab(res.data.data[0], index++);   
                }
            }
        },   
        
        newTab(data, i){
            if(data.tingkat < 5){   
                for(let j=this.tabs.length; j >= (i) ; j--){
                    this.tabs.splice(j, 1);
                }
                if(!this.tabs[i]){
                    this.tabs.push({name:data.name, calons:data.calons, area_ids:[], tingkat_ids:[], show:false, areaSearch:null, area:{data:[], count:0, page:1, time:null}});             
                    let ctx= this; setTimeout(function(){ctx.tabs[i].show= true;},100);
                }
                Object.assign(this.tabs[i], data);                    
                
                this.active = i;                                
                if(i > 0){
                  this.$watch(['tabs',i,'areaSearch'].join('.'), (val)=>{ 
                    const ctx = this; setTimeout(function(){
                       if(val === ctx.tabs[i].areaSearch){
                          ctx.setAreas(ctx.tabs[i], true); 
                       }
                    }, 700); 
                  });
                  this.setAreas(this.tabs[i], true);

                  var area_ids = []; var tingkat_ids = []; 
                  for(let j=1; j<this.tabs.length; j++){
                      area_ids.push(this.tabs[j].area_id);
                      tingkat_ids.push(this.tabs[j].tingkat);
                  }
                  
                  this.setCalons(i);
                  
                  if(i === 1){
                    this.dapilRoute(area_ids, tingkat_ids, data.dapil_id); 
                  } else {
                    this.hitungRoute(area_ids, tingkat_ids); 
                  }
                } else {
                  this.$watch(['tabs',i,'areaSearch'].join('.'), (val)=>{ 
                    setTimeout(() => {
                       if(val === this.tabs[i].areaSearch){
                          this.setDapils(this.tabs[i], true);
                       }
                    }, 1000);                     
                  });
                  this.setDapils(this.tabs[i], true);
                }                                
            } else {              
              if(data.sah && data.sah.sah > 0){
                this.showDialog(this.kompetisi.id, data.id, this.kompetisi.mode);
              } else {
                window.getApp.$emit('showSnackbar', {
                    show : true,text : 'No Data Result', color: 'warning'
                });
              }
              //this.formRoute(data.id);                
            }
        },
        
        showDialog(kompetisi_id, tps_id, mode){                        
            Object.assign(this.cekup, {kompetisi_id : kompetisi_id, tps_id:tps_id, mode:mode});
            this.dialog = true;
        },
        
        setCalons(i){ 
            let total_suara = 0
            this.tabs[i].calons.forEach((item, j)=>{ 
                var value = this.quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value ? value : 0
                total_suara += parseInt(value); 
            })
            this.tabs[i].calons.forEach((item, j)=>{                
                var value = this.quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value ? parseFloat(parseInt(value)/total_suara*100) : 0
                value = value ? value.toFixed(2) : 0
                this.tabs[i].calons[j].value = value;  
            });                        
        },
        
        refreshKompetisi(i){          
          let fm = this.tabs[i];          
          this.loading =true;
          if(i > 0){
            if(i === 1){
              model.dapils({tingkat:fm.tingkat,'DapilSearch[id]':fm.dapil_id,kompetisi_id:this.$route.query.kompetisi_id}).then(res=>{
                  Object.assign(fm, res.data.data[0]);
                  this.setCalons(i);
                  this.setAreas(fm, true);
              });
            } else {
              model.areas({dapil_id:this.$route.query.dapil_id,tingkat:fm.tingkat,'AreaSearch[id]':fm.area_id,kompetisi_id:this.$route.query.kompetisi_id}).then(res=>{
                  Object.assign(fm, res.data.data[0]);
                  this.setCalons(i);
                  this.setAreas(fm, true);
              });
            }            
          } else {
            //this.setCalons(i);
            this.setDapils(fm, true);                        
          }
        },                             
          
        persenContain(contain){
            return this.quickcountMode?(contain.quick/contain.all*100).toFixed(2):(contain.done/contain.all*100).toFixed(2);
        },

        colorPersen(persen){
            if(persen >= 0 && persen <=40)return 'red';
            else if(persen <=60)return 'orange';
            else if(persen <=80)return 'yellow';
            else if(persen <=99)return 'blue';
            else return 'green';        
        },
        
        firstLetter (name) {
            return name.charAt(0);
        },                
        
        setAreas(fm, reset = false){            
            this.loading = true;    
            if(!fm) return;
            if(reset) fm.area.page = 1;
            var dapil_id = this.$route.query.dapil_id;
            model.areas({dapil_id: fm.dapil_id?fm.dapil_id:dapil_id,tingkat: (parseInt(fm.tingkat) + 1), kompetisi_id:this.kompetisi_id,'AreaSearch[parent_id]':fm.area_id, page:fm.area.page, 'AreaSearch[name]':fm.areaSearch}).then(resp=>{
                if(reset) {fm.area.data = []; fm.area.page = 1;}                
                fm.area.data    = [...fm.area.data, ...resp.data.data];                
                fm.area.page++;
                fm.area.count = resp.data.count; 
                fm.area.time  = resp.data.time; 
                if(reset && fm.area.data.length == 0) {fm.area.page = 1;}
                this.loading = false;
            });
        },  
        
        setDapils(fm, reset = false){
            this.loading = true;    
            if(!fm) return;
            if(reset) fm.area.page = 1;
            model.dapils({kompetisi_id:this.kompetisi_id,page:fm.area.page, 'DapilSearch[name]':fm.areaSearch}).then(resp=>{
                if(reset) {fm.area.data = []; fm.area.page = 1;}                
                fm.area.data    = [...fm.area.data, ...resp.data.data];                
                fm.area.page++;
                fm.area.count = resp.data.count; 
                fm.area.time  = resp.data.time; 
                if(reset && fm.area.data.length == 0) {fm.area.page = 1;}
                this.loading = false;
            });
        },
        
        setBar1Option(data, quickcountMode=false){            
            let newOption  = JSON.parse(JSON.stringify(DBar1.option));
            let seriesData = [], legendData = []; this.calons = [];        
            let total_suara = 0;   
            data.calons.forEach(item=>{
                var value = quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value ? value : 0
                total_suara += parseInt(value);
            })
            data.calons.forEach(item=>{
                var value = quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value > 0 ? value : 0;
                value = parseFloat(value/total_suara*100);
                value = value > 0 ? value.toFixed(2):0
                var name  = item.no+'. '+item.akronim;
                seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
                legendData.push(item.no);                
            });
            newOption.series[0].data = seriesData;   
            newOption.xAxis[0].data  = legendData;
            //newOption.legend.data    = legendData;      
            //console.log(newOption);
            return newOption;
        },
        
        setBar2Option(data, quickcountMode=false){            
            let newOption  = JSON.parse(JSON.stringify(DBar2.option));
            let seriesData = [], legendData = []; this.calons = [];
            let total_suara = 0;   
            data.calons.forEach(item=>{
                var value = quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value ? value : 0
                total_suara += parseInt(value);
            })
            data.calons.forEach(item=>{
                var value = quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value > 0 ? value : null;                      
                var name  = item.no+'. '+item.akronim;
                seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
                legendData.push(item.no);                
            });
            newOption.series[0].data = seriesData;   
            newOption.xAxis[0].data  = legendData;
            //newOption.legend.data    = legendData;      
            //console.log(newOption);
            return newOption;
        },
        
        setBar3Option(data, quickcountMode=false){            
            let newOption  = JSON.parse(JSON.stringify(DBar3.option));
            let seriesData = [], legendData = [], arrval=[]; this.calons = [];        
            let total_suara = 0;   
            data.calons.forEach(item=>{
                var value = quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value ? value : 0
                total_suara += parseInt(value);
            })
            data.calons.forEach(item=>{
                var value = quickcountMode?item.hitung.quickcount:item.hitung.suara; 
                value = value > 0 ? value : 0;
                value = parseFloat(value/total_suara*100);
                value = value > 0 ? value.toFixed(2):0
                var name  = item.no+'. '+item.akronim;
                arrval.push(value);
                seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
                legendData.push(item.no);                
            });
            newOption.series[0].data = seriesData;  
            newOption.series[0].markLine.data[0] = {name: 'Batas Kuota', yAxis:this.getMinKuota(arrval, data.kuota)};
            newOption.xAxis[0].data  = legendData;
            
            //newOption.legend.data    = legendData;      
            //console.log(newOption);
            return newOption;
        },
        
        getMinKuota(arr, kuota){
          arr.sort(function(a,b){
              return b-a;
          });
          return arr[kuota-1]?arr[kuota-1]:0;
        },                
        
        areaRoute (id, tingkat) {
            this.$router.push({path:'/dashboard/explore', query: {kompetisi_id: id, tingkat: tingkat}});
        },                
        
        formRoute(tps_id){
            let q = this.$route.query;
            this.$router.push({path:'/hitung/form', query: {
                kompetisi_id : q.kompetisi_id,
                mode : this.kompetisi.mode,
                tps_id : tps_id, 
            }});
        },
        
        hitungRoute(area_ids, tingkat_ids){
            let q = this.$route.query;
            this.$router.push({path:'/dashboard/explore', query: {
                kompetisi_id : q.kompetisi_id,
                mode : q.mode,
                tingkat : q.tingkat,
                dapil_id : q.dapil_id,
                area_ids : area_ids,
                tingkat_ids : tingkat_ids,                
            }});
        },
        
        dapilRoute(area_ids, tingkat_ids, dapil_id){
            let q = this.$route.query;
            this.$router.push({path:'/dashboard/explore', query: {
                kompetisi_id : q.kompetisi_id,
                mode : q.mode,
                tingkat : q.tingkat,
                dapil_id : dapil_id,
                area_ids : area_ids,
                tingkat_ids : tingkat_ids,                
            }});
        },
        
        liveRoute(dapil_id){
          let q = this.$route.query;
          return {path:'/dashboard/live', query:{
              kompetisi_id:q.kompetisi_id,
              mode:q.mode,
              dapil_id:dapil_id
            }
          };
        },
        
        urutkan(arrA, arrB){
            for(var i=0; i<arrA.length; i++){
              for(var j=i+1; j<arrA.length; j++){
                if(arrA[i]>arrA[j]){
                    var tmpA=arrA[i]; var tmpB=arrB[i]; 
                    arrA[i]=arrA[j];  arrB[i]=arrB[j];
                    arrA[j]=tmpA;     arrB[j]=tmpB;
                }     
              }   
            }
            var result = [];
            for(var i=0; i<arrA.length; i++){
              result.push({a:arrA[i], b:arrB[i]});
            }            
            return result;            
        }
    }
}
</script>
  
